import { render, staticRenderFns } from "./ListItemDelete.vue?vue&type=template&id=c1b0c3e0&lang=pug&"
import script from "./ListItemDelete.vue?vue&type=script&lang=js&"
export * from "./ListItemDelete.vue?vue&type=script&lang=js&"
import style0 from "./ListItemDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports